import * as React from 'react';

import EnterpriseAutoEnrolledCoursesDataProvider from 'bundles/unified-common/providers/EnterpriseAutoEnrolledCoursesDataProvider';
import EnterpriseCareerAcademyVariantDataProvider from 'bundles/unified-common/providers/EnterpriseCareerAcademyVariantDataProvider';
import EnterpriseModalManagerProvider from 'bundles/unified-common/providers/EnterpriseModalManagerProvider';
import EnterpriseProductFeaturesDataProvider from 'bundles/unified-common/providers/EnterpriseProductFeaturesDataProvider';
import EnterpriseProgramDataProvider from 'bundles/unified-common/providers/EnterpriseProgramDataProvider';
import EnterpriseAvailableEnrollmentProgramsDataProvider from 'bundles/unified-description-page-common/providers/enterprise/EnterpriseAvailableEnrollmentProgramsDataProvider';

const EnterpriseDescriptionPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnterpriseProgramDataProvider>
      <EnterpriseProductFeaturesDataProvider>
        <EnterpriseAutoEnrolledCoursesDataProvider>
          <EnterpriseCareerAcademyVariantDataProvider>
            <EnterpriseAvailableEnrollmentProgramsDataProvider>
              <EnterpriseModalManagerProvider>{children}</EnterpriseModalManagerProvider>
            </EnterpriseAvailableEnrollmentProgramsDataProvider>
          </EnterpriseCareerAcademyVariantDataProvider>
        </EnterpriseAutoEnrolledCoursesDataProvider>
      </EnterpriseProductFeaturesDataProvider>
    </EnterpriseProgramDataProvider>
  );
};

export default EnterpriseDescriptionPageDataProvider;
